import { 
    LOADING_POST,
    POST_ONE_POST,
    GET_ALL_POSTS,
    SET_POST,
    UPDATE_POST,
    FILTER_POST,
 } from '../types';

const initialState = {
    posts: [],
    post: {},
    loading: false,
    title: '',
    status: '-1',
}

var findIndex = (initialState, id) => {
    var result = -1;
    initialState.posts.forEach((post, index) => {
        if(post.postId === id) {
            result = index;
        }
    });
    
    return result;
}

export default function(state = initialState, action) {
    var id = '';
    var updateChange = '';
    var index = -1;
    switch(action.type){
        case LOADING_POST:
            return {
                ...state,
                loading: true
            };
        case GET_ALL_POSTS:
                return {
                    ...state,
                    posts: action.payload,
                };
        case POST_ONE_POST:
            state.posts.push(action.payload);
            return {
                ...state,
                loading: false
            }
        case UPDATE_POST: 
            id = action.postId;
            updateChange = action.payload;
            index = findIndex(state, id);
            state.posts[index] = {
                ...updateChange
            };
            state.post = {
                ...updateChange
            };
            return state;
        case SET_POST:
            return {
                ...state,
                post: action.payload,
                loading: false
            }
        case FILTER_POST:
            return {
                ...state,
                title: action.filter.title,
                status: action.filter.status,
            }
        default:
            return state;
    }
}